import React from 'react';
import { NavLink } from 'react-router-dom';
import Header2 from './../Common/Header2';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

const CareersList = [
    // {
    //     image: require('./../../images/careers/BillingEngineer.jpg'),
    //     title: 'Billing Engineer',
    //     qualification: 'Qualification: Degree / Diploma in Civil Engineeing',
    //     experience: 'Experience: 8-10 years in High Rise Building',
    //     location: 'Location: Kolkata / Odisha'
    // },
    {
        image: require('./../../images/careers/BillingEngineer.jpg'),
        title: 'Billing Engineer',
        qualification: 'Qualification: Diploma in Civil Engineering',
        experience: 'Experience: Min 5 Years experience in Multi-storied Building Structures',
        location: 'Location: Bhubaneswar/Ranchi/Kolkata'
    },
    {
        image: require('./../../images/careers/SiteEngineer.jpg'),
        title: 'Site Engineer',
        qualification: 'Qualification: Diploma in Civil Engineering',
        experience: 'Experience: Min 5 to 7 years of experience in Multi-storied Building Structures',
        location: 'Location: Bhubaneswar/Ranchi/Kolkata'
    },
    {
        image: require('./../../images/careers/Surveyor.jpg'),
        title: 'Surveyor',
        qualification: 'Qualification: Diploma in Civil Engineering',
        experience: 'Experience: Min 5 to 7 years of experience in Multi storey Building Structures',
        location: 'Location: Bhubaneswar/Ranchi/Kolkata'
    }
]

var bnrimg = require('./../../images/banner/5.jpg');

class Careers extends React.Component {
    render() {
        return (
            <>
                <Header2 />
                <div className="page-content">
                <Banner title="Careers" pagename="Careers" description="" bgimage={bnrimg} />
                    {/* SHOP SECTION START */}
                    <div className="section-full p-t120 p-b90 bg-white mobile-page-padding">
                        <div className="container">
                            <div className="row d-flex justify-content-center">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-b30">
                                    <div className="shop-item-list-wrap-outer">
                                        {CareersList.map((item, index) => (
                                            <div key={index} className="shop-item-list-wrap m-b30">
                                                <div className="sx-box sx-product-box   overflow-hide">
                                                    <div className="sx-thum-bx sx-img-overlay1">
                                                        <img src={item.image} alt="" />
                                                    </div>
                                                    <div className="sx-info careers">
                                                        <h5 className="sx-title">{item.title}</h5>
                                                        <p>{item.qualification}</p>
                                                        <p>{item.experience}</p>
                                                        <p>{item.location}</p>
                                                        <NavLink className="site-cart-btn site-button m-t25" to="/contact-us">Apply Now</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SHOP SECTION END */}
                </div>

                <Footer />
            </>
        );
    };
};

export default Careers;

